module.exports = __webpack_public_path__ + "img/promo_banner_touch.d9c9e11b.png";